// extracted by mini-css-extract-plugin
export default {"overall":"Checkboxes_overall__exQQc"};